// src/components/PasswordReset.js

import React, { useState } from 'react';
import { FaEnvelope } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import supabase from '../supabase';

const PasswordReset = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    const redirectTo = process.env.REACT_APP_REDIRECT_URL || `${window.location.origin}/update-password`;

    const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo,
    });

    if (error) {
      setMessage(`Error: ${error.message}`);
    } else {
      setMessage('Password reset email sent! Please check your inbox.');
    }

    setLoading(false);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-b from-orange-500 via-red-500 to-black">
      <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-md">
        {/* Header */}
        <div className="flex justify-center mb-2">
          <FaEnvelope className="text-blue-800 text-3xl"/>
        </div>

        <h1 className="mt-4 text-2xl font-bold text-center text-blue-800"> 
          Reset Password
        </h1>
        
        <p className="mt-4 text-sm text-center text-blue-500">
          Enter your email to receive a password reset link
        </p>

        {/* Email Input */}
        <form onSubmit={handlePasswordReset} className="mt-6">
          <div>
            <label htmlFor="email" className="sr-only">Email</label>
            <input
              id="email"
              type="email"
              placeholder="Email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-2 mt-2 text-sm text-blue-700 border rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400"
            />
          </div>

          {/* Reset Button */}
          <button
            type="submit"
            disabled={loading}
            className="w-full flex items-center justify-center px-4 py-2 mt-4 text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-yellow-400"
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        {/* Back to Login Link */}
        <p className="mt-4 text-sm text-center text-blue-600">
          Remembered your password?{' '}
          <Link to="/" className="text-yellow-500 hover:underline">
            Login
          </Link>
        </p>

        {/* Message */}
        {message && <p className="mt-4 text-sm text-center text-red-500">{message}</p>}
      </div>
    </div>
  );
};

export default PasswordReset;
